module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(!_vm.demofi_ejecutandose) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "value": true
    }
  }, [_c('h3', {
    staticClass: "headline warning--text"
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v(" Atención.-")], 1), _vm._v(" "), _c('p', [_vm._v("Demofi no se está ejecutando en su equipo o no tiene agregado el certificado de seguridad en su navegador. Haga:")]), _vm._v(" "), _c('p', [_vm._v("1. Visite el siguiente enlace para su instalación y/o configuración. Presione "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://firmadigital.bo/jacobitus4/"
    }
  }, [_vm._v("aquí")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "margin-0"
  }, [_vm._v("2. Puede verificar que el certificado de seguridad de Demofi se encuentra instalado. Presione "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.verCertificado()
      }
    }
  }, [_vm._v("aquí")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), (_vm.demofi_ejecutandose && !_vm.autenticado) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\n    Ingrese el PIN de su Token para poder firmar el documento.\n  ")]) : _vm._e(), _vm._v(" "), (_vm.certificados.length) ? _c('v-alert', {
    attrs: {
      "outline": "",
      "color": "success",
      "icon": "check",
      "value": true
    }
  }, [_vm._v("\n    Token iniciado correctamente\n  ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.autenticar($event)
      }
    }
  }, [(!_vm.autenticado && !_vm.$store.state.pin) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Pin",
      "type": "password",
      "prepend-icon": "verified_user",
      "rules": _vm.$validate(['required']),
      "disabled": !_vm.token_conectado || _vm.autenticado
    },
    model: {
      value: (_vm.pin),
      callback: function($$v) {
        _vm.pin = $$v
      },
      expression: "pin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary",
      "disabled": !_vm.token_conectado || _vm.autenticado
    }
  }, [_vm._v(" Autenticar\n            ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.certificados.length) ? _c('div', [_c('h4', [_c('v-icon', [_vm._v("person")]), _vm._v(" Información del Token")], 1), _vm._v(" "), (_vm.segmento) ? _c('div', {
    staticClass: "demofi-certificado"
  }, [_c('p', [_c('strong', [_vm._v("Nombre:")]), _vm._v(" " + _vm._s(_vm.firmador.nombreComunSubject))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Organización:")]), _vm._v(" " + _vm._s(_vm.firmador.organizacionSubject))]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Token válido desde el "), _c('strong', [_vm._v(_vm._s(_vm.firmador.inicioValidez))]), _vm._v(" hasta el "), _c('strong', [_vm._v(_vm._s(_vm.firmador.finValidez))])])])]) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "p-b-0",
    attrs: {
      "label": "Certificado",
      "rules": _vm.$validate(['required']),
      "prepend-icon": "person",
      "disabled": !_vm.autenticado,
      "item-text": "nombreComunSubject",
      "item-value": "numeroSerie",
      "items": _vm.certificados
    },
    model: {
      value: (_vm.firmadorSeleccionado),
      callback: function($$v) {
        _vm.firmadorSeleccionado = $$v
      },
      expression: "firmadorSeleccionado"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "center": ""
    }
  }, [(_vm.existeCertificados) ? [(_vm.certificados.length) ? _c('v-btn', {
    attrs: {
      "id": "btn-demofi-firm",
      "color": "success",
      "disabled": !_vm.autenticado || _vm.firmando
    },
    on: {
      "click": _vm.firmar
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("security")]), _vm._v("Firmar")], 1) : _vm._e()] : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.certificados.length === 0 && _vm.autenticado),
      expression: "certificados.length === 0 && autenticado"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "warning"
    }
  }, [_vm._v("warning")]), _vm._v("No se encontraron certificados válidos en su token\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eda45630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/util/Demofi.vue
// module id = 538
// module chunks = 2